import { Component, Input } from '@angular/core';

import { MonitoringKeywordGroupModel } from '../../models/monitoring-keyword-group.model';
import { ControlValueAccessorModel, getProvider } from '../../../../Common/Forms/models/control-value-accessor.model';
import { ButtonTypesEnum } from '../../../../Common/Forms/enums/button-types.enum';

@Component({
    selector: 'agpr-monitoring-keywords',
    templateUrl: './monitoring-keywords.component.html',
    styleUrls: ['./monitoring-keywords.component.scss'],
    providers: [getProvider(MonitoringKeywordsComponent)],
    standalone: false
})
export class MonitoringKeywordsComponent extends ControlValueAccessorModel<MonitoringKeywordGroupModel> {
    @Input() id: string = null;
    @Input() styleClass: string;
    @Input() isImageSearch: boolean = false;

    value: MonitoringKeywordGroupModel;

    readonly splitOnPattern: RegExp = /(")?,(?=(?:[^\"]*\"[^\"]*\")*[^\"]*$)\1 */g;
    readonly buttonTypes = ButtonTypesEnum;

    constructor() {
        super();
    }
}
